var _excluded = ["children", "show", "container", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Portal from '@adsk/alloy-react-portal';
import { PLACEMENTS } from './consts';
import useOverlay from './hooks/useOverlay';

/**
 * React Overlay wrapper component for useOverlay.
 * DEPRECATED:  Use Overlay instead or useOverlay directly.
 */
var OverlayDeprecated = function OverlayDeprecated(_ref) {
  var children = _ref.children,
      showProp = _ref.show,
      container = _ref.container,
      placementProp = _ref.placement,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useOverlay = useOverlay(_objectSpread({
    placement: placementProp,
    show: showProp
  }, props)),
      show = _useOverlay.show,
      placement = _useOverlay.placement,
      overlayProps = _useOverlay.overlayProps,
      arrowProps = _useOverlay.arrowProps;

  return show ? /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, children({
    props: overlayProps,
    arrowProps: arrowProps,
    placement: placement
  })) : null;
};

OverlayDeprecated.displayName = 'OverlayDeprecated';
OverlayDeprecated.defaultProps = {
  placement: PLACEMENTS.BOTTOM,
  container: document.body
};
OverlayDeprecated.propTypes = {
  /**
   * whether the popover is showed or not. should be sent only for
   * controlled elements
   */
  show: PropTypes.bool,

  /**
   * callback to be called on show
   */
  onShow: PropTypes.func,

  /**
   * callback to be called on hide
   */
  onHide: PropTypes.func,

  /**
   * delay before show in milliseconds
   */
  delayShow: PropTypes.number,

  /**
   * delay before hide in milliseconds
   */
  delayHide: PropTypes.number,

  /** overlay position according to Overlay placements. */
  placement: PropTypes.oneOf(Object.values(useOverlay.PLACEMENTS)),

  /** target element ref (get/set).  */
  target: PropTypes.object,

  /** overlay ref to overlay dom element. */
  overlayRef: PropTypes.any,

  /** Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay. */
  rootClose: PropTypes.bool,

  /** Dependency to pass to usePopper's useLayoutEffect hook */
  layoutDependency: PropTypes.any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   outOfBoundaries: ?boolean,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */
  children: PropTypes.func.isRequired
};
export default OverlayDeprecated;
//# sourceMappingURL=OverlayDeprecated.js.map